export default "__VITE_ASSET__BP30Q6Ls__"